import { render, staticRenderFns } from "./InfoList.vue?vue&type=template&id=3deb979e&scoped=true"
import script from "./InfoList.vue?vue&type=script&lang=js"
export * from "./InfoList.vue?vue&type=script&lang=js"
import style0 from "./InfoList.vue?vue&type=style&index=0&id=3deb979e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3deb979e",
  null
  
)

export default component.exports